import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps

  [prop: string]: any
}

export const FiveSecondBackwardIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 16 20"
    sx={{ width: '16px', height: '20px', color: 'primary500', ...sx }}
    {...props}
  >
    <path
      d="M8.50009 4.01536C8.22447 3.99838 8 3.77614 8 3.5V1.20711C8 0.761654 7.46143 0.538571 7.14645 0.853553L3.35355 4.64645C3.15829 4.84171 3.15829 5.15829 3.35355 5.35355L7.14645 9.14645C7.46143 9.46143 8 9.23835 8 8.79289V6.5C8 6.22386 8.22464 5.99782 8.49984 6.02059C11.5766 6.27517 14 8.85831 14 12C14 15.31 11.31 18 8 18C4.85831 18 2.27517 15.5766 2.02059 12.4998C1.99782 12.2246 1.77614 12 1.5 12H0.5C0.223858 12 -0.00162169 12.2245 0.0153583 12.5001C0.273294 16.6869 3.74796 20 8 20C12.42 20 16 16.42 16 12C16 7.74796 12.6869 4.27329 8.50009 4.01536Z"
      fill="inherit"
    />
    <path
      d="M6.69001 12.9L6.94001 10.73H9.33001V11.44H7.63001L7.52001 12.36C7.55001 12.34 7.59001 12.33 7.63001 12.31C7.67001 12.29 7.72001 12.27 7.78001 12.26C7.84001 12.25 7.90001 12.23 7.96001 12.22C8.02001 12.21 8.09001 12.2 8.16001 12.2C8.37001 12.2 8.55001 12.23 8.71001 12.3C8.87001 12.37 9.01001 12.46 9.12001 12.58C9.23001 12.7 9.32001 12.85 9.37001 13.03C9.42001 13.21 9.46001 13.41 9.46001 13.63C9.46001 13.82 9.43001 14 9.37001 14.17C9.31001 14.34 9.22001 14.49 9.10001 14.62C8.98001 14.75 8.83001 14.86 8.65001 14.93C8.47001 15 8.26001 15.05 8.01001 15.05C7.83001 15.05 7.65001 15.02 7.48001 14.97C7.31001 14.92 7.16001 14.83 7.02001 14.73C6.88001 14.63 6.78001 14.49 6.70001 14.34C6.62001 14.19 6.57001 14.01 6.57001 13.81H7.41001C7.43001 13.99 7.49001 14.13 7.60001 14.22C7.71001 14.31 7.85001 14.37 8.02001 14.37C8.13001 14.37 8.22001 14.35 8.29001 14.31C8.36001 14.27 8.43001 14.21 8.47001 14.14C8.51001 14.07 8.55001 13.99 8.58001 13.89C8.61001 13.79 8.61001 13.69 8.61001 13.58C8.61001 13.47 8.60001 13.37 8.57001 13.27C8.54001 13.17 8.50001 13.1 8.44001 13.03C8.38001 12.96 8.31001 12.91 8.23001 12.88C8.15001 12.85 8.04001 12.83 7.93001 12.83C7.85001 12.83 7.78001 12.84 7.73001 12.85C7.68001 12.86 7.62001 12.88 7.58001 12.9C7.54001 12.92 7.50001 12.95 7.46001 12.97C7.42001 12.99 7.39001 13.03 7.36001 13.06L6.69001 12.9Z"
      fill="inherit"
    />
  </SvgIcon>
)

FiveSecondBackwardIcon.defaultProps = {
  sx: {},
}
